module.exports = __webpack_public_path__ + "img/user.923fdb55.svg";